import { render } from "./VocationalCongregationalLeadership.vue?vue&type=template&id=7761fef6&scoped=true"
import script from "./VocationalCongregationalLeadership.vue?vue&type=script&lang=js"
export * from "./VocationalCongregationalLeadership.vue?vue&type=script&lang=js"

import "./VocationalCongregationalLeadership.vue?vue&type=style&index=0&id=7761fef6&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7761fef6"]])

export default __exports__